import { Checkbox } from '@mui/material';
import { useTranslation } from 'next-i18next';
import React from 'react';
import { BoothsComponentInterface } from '../../../../../../interfaces/pagebuilder';
import { useSelector } from '../../../../../../reduxToolkit/typedRedux';
import { TitleAndDescription } from '../../../../pageBuilder/TitleAndDescription';
import BoothFilters from '../../oneonone/BoothFilters';
import Search from './Search';

interface TitleRowProps {
  uiComponent: BoothsComponentInterface;
  onSearch: (query: string) => void;
  onShowOnlineBooths: (val: boolean) => void;
  showOnlyOnlineBooths: boolean;
  onFilter: (filters: any) => void;
}

export const TitleRow = (props: TitleRowProps) => {
  const { uiComponent, showOnlyOnlineBooths, onSearch, onShowOnlineBooths, onFilter } = props;

  const event = useSelector((state) => state.common.event);
  const { t } = useTranslation();

  if (!uiComponent || !event) return <></>;

  return (
    <>
      <TitleAndDescription component={uiComponent!} />
      <div
        className={`flex flex-col @sm:flex-row ${
          event.modules.advancedFilters.active && (uiComponent?.showFilter || uiComponent?.showIsOnlineCheckbox) ? 'justify-between' : 'justify-end'
        }`}>
        <div className="flex flex-row justify-center items-center">
          {event.modules.advancedFilters.active && uiComponent?.showFilter && (
            <BoothFilters
              fetchFromEvent={false}
              onChange={(filters: any) => onFilter(filters)}
              description={uiComponent?.filterDescription}
              preselectedFilterValueId={uiComponent.preselectedFilter?.datetime_deleted === undefined ? uiComponent.preselectedFilter?._id : undefined}
            />
          )}
          {uiComponent?.showIsOnlineCheckbox !== false && (
            <div className={`mr-2 flex flex-row justify-center items-center text-slate-800`}>
              <Checkbox
                style={{ color: event?.template?.complementColor, paddingLeft: 0 }}
                value={showOnlyOnlineBooths}
                onChange={(e) => onShowOnlineBooths(e.target.checked)}
              />
              <b>{t('booth:currently-online')}</b>
            </div>
          )}
        </div>
        {uiComponent?.showSearch && <Search fetchFromEvent={false} onChange={(searchPhrase: string) => onSearch(searchPhrase)} />}
      </div>
    </>
  );
};
